export default __webpack_public_path__ + "static/media/introback3.1f30bd85.png";